import type { SpaceResource } from "@octopusdeploy/octopus-server-client";
import { Environment } from "@octopusdeploy/utilities";
import * as React from "react";
import URI from "urijs";
import { StorageContextualHelp } from "~/areas/infrastructure/components/MachineSettings/Endpoints/KubernetesAgent/StorageContextualHelp";
import type { EndpointSelectionScope } from "~/areas/infrastructure/components/MachineSettings/Endpoints/endpointRegistry";
import { client } from "~/clientInstance";
export interface BaseConfiguration extends AgentConfiguration, MonitorConfiguration {
}
export interface AgentConfiguration {
    Space: SpaceResource | undefined;
    Name: string;
    ServerUri: string;
    ServerNodeCommsAddresses: {
        nodeName: string;
        commsAddress: string;
    }[];
    AccessToken: string;
    StorageClassName: string;
    DefaultClusterRolePermissions: string | null;
}
export interface MonitorConfiguration {
    SpaceId: string;
    Name: string;
    ServerUri: string;
    AccessToken: string;
    ServerGrpcUri: string;
}
export function getServerGrpcUri(): string {
    return new URI(client.resolve("/")).port("8443").protocol("grpc").toString().replace(/\/$/, "");
}
export function getBackendServerUrl(): string {
    if (Environment.isInDevelopmentMode()) {
        const serverUrl = new URL(window.location.href).searchParams.get("octopus.server");
        if (serverUrl) {
            return new URL(serverUrl).toString();
        }
    }
    return client.resolve("/");
}
export const ConfigurationPageStorageClassHelperContent = (machineType: EndpointSelectionScope) => (<span>
        Provide a Storage Class <StorageContextualHelp machineType={machineType}/> or leave this blank to use the default NFS storage
    </span>);
